import { Controller } from "@hotwired/stimulus";

/**
 * キャンペーン経由のカート追加を計測するため、商品カードのリンクに流入元のキャンペーンIDを付けるコントローラー
 *
 * 使用場所:
 * - イチオシ商品コンポーネント（#featured-products-{キャンペーンID}）
 * - キャンペーン商品一覧ページの商品一覧（#products-list）
 *
 * 商品カードはイチオシ枠と通常一覧で同じHTMLに再描画されるため、カード側には文脈を持たせられない。
 * そこで文脈はこのコントローラーを置いた外側の要素が持ち、クリックの瞬間にリンクのURLへ付け足す。
 * Turbo はリンク遷移を window の bubbling 段階で処理するので、ここで書き換えた href が取得先になる。
 *
 * 必要な属性:
 * - data-campaign-attribution-campaign-id-value: 流入元のキャンペーンID
 * - 対象リンクの data-campaign-link: "product_detail"（商品詳細モーダル） / "cart_modal"（数量モーダル）
 */
export default class extends Controller {
  static values = {
    campaignId: Number,
  };

  connect() {
    this.handleClick = this.tagLink.bind(this);
    this.element.addEventListener("click", this.handleClick);
  }

  disconnect() {
    this.element.removeEventListener("click", this.handleClick);
  }

  // クリックされたリンクのURLに campaign_id を付ける（何度押しても同じURLになる）
  tagLink(event) {
    const link = event.target.closest(
      'a[data-campaign-link="product_detail"], a[data-campaign-link="cart_modal"]'
    );
    if (!link || !this.element.contains(link)) return;

    const url = new URL(link.href, window.location.origin);
    url.searchParams.set("campaign_id", this.campaignIdValue);
    link.href = url.toString();
  }
}
